import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	showProfile: false,   // show profile modal when true
	activeTab: '',
	successMessage: '',
	errorMessage: "Field(s) cannot be blank.",
	showSuccess: false,
	canSave: false,
	isLoading: false,
	password: '', //placeholder for password
    savingError: false,
}

const getters = {

}


// mutations
const mutations = {
	/**
	 * Mutate any boolean variable
	 * @param {string}
	 * @param {boolean}
	 */
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	/**
	 * Set active tab
	 * @param {string}
	 */
	SET_ACTIVE_TAB(state, tabName){
		state.activeTab = tabName
	},
}

// actions
const actions = {
	/**
	 * Toggle boolean keys
	 * @param {string}
	 * @param {boolean}
	 */
	setBoolean({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	/**
	 * Keep track of current profile tab
	 * @param {string}
	 */
	setActiveTab({commit}, tabName){
		commit('SET_ACTIVE_TAB', tabName);
	},

	/**
	 * Validate before closing modal
	 */
	validateModal({commit, dispatch, state, rootState}){
		if(state.canSave){
			VueStore.dispatch('notify/setShowMessage', {key: 'showAccountNotSaved', bool: true});
		} else {
			dispatch('closeModal');
		}
	},

	/**
	 * Close modal
	 */
	closeModal({commit, dispatch}){
		commit('TOGGLE_BOOLEAN_STATE', {key: 'showProfile', bool: false});
		commit('TOGGLE_BOOLEAN_STATE', {key: 'savingError', bool: false});
        VueStore.dispatch('user/setBoolean', {key: 'canSave', bool: false});
        //VueStore.dispatch('vendors/toggleBooleanState', {key: 'canSave', bool: false});
        VueStore.dispatch('vendors/clear');
	},

	/**
	 * Call API to save into vendor data first and then user data
	 *
	 */
	update({commit, dispatch, state, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var user = rootState.user.user;
		var vendor_id = user.userable_id;
		var user_id = user.id;
		var countSavedSuccess = 0;  //count successful save

		// get requsters data (first_name, last_name, business_phone)
		var vendorsDataForServer = rootState.vendors.dataForServer;

		// get user data (username and password)
		var userDataForServer = rootState.user.dataForServer;

		// save into vendors endpoint
		if(typeof (vendor_id) !== 'undefined'){
			var url = rootState.auth.l+'v1/vendors/'+vendor_id;
			axios.put(url,vendorsDataForServer,header)
			.then(response => {
				// increment count
				countSavedSuccess = countSavedSuccess + 1;

				// If user_id exist, update existing location
				if(typeof user_id !== 'undefined'){
					var url = rootState.auth.l+'v1/users/'+user_id;
					axios.put(url,userDataForServer,header)
					.then(response => {
						// increment count
						countSavedSuccess = countSavedSuccess + 1;
						VueStore.dispatch('user/getUserData');
						dispatch('finalizeUpdate', countSavedSuccess)
					}).catch((error) => {
						dispatch('auth/checkError', error, {root: true})
					});
				}
			}).catch((error) => {
				dispatch('auth/checkError', error, {root: true})
			});
		}
	},

	finalizeUpdate({commit, dispatch}, countSavedSuccess){
		if(countSavedSuccess == 2){
			commit('TOGGLE_BOOLEAN_STATE', {key: 'savingError', bool: false})
			commit('TOGGLE_BOOLEAN_STATE', {key: 'canSave', bool: false})
			commit('TOGGLE_BOOLEAN_STATE', {key: 'isLoading', bool: false})
			commit('TOGGLE_BOOLEAN_STATE', {key: 'showProfile', bool: false}) // close profile modal

			VueStore.dispatch('notify/setShowMessage', {key: 'showAccountSaved', bool: true})
		} else {
			commit('TOGGLE_BOOLEAN_STATE', {key: 'savingError', bool: true})
		}
	}



}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}
